// @ts-nocheck
/* eslint-disable */
import React from 'react';
import { createRoot } from 'react-dom/client';
import RouterLoggedOut from './routers/RouterLoggedOut';

import debugLib from 'debug';
import '../../less/loggedout/styles.less';
import { ConsoleSuppressor } from '../common/support/ConsoleSuppressor';
import { tryLoadAndStartRecorder } from '@alwaysmeticulous/recorder-loader';

new ConsoleSuppressor(window, console).hideWarnings();

window.DBDebug = debugLib;
window.addEventListener('load', () => {
  const container = document.getElementById('app');
  const root = createRoot(container);
  root.render(<RouterLoggedOut />);
});
